import React from "react";
import "./index.scss";

export default function xRegisterWrapper({ image, children }) {
  return (
    <div className="register-wrapper">
      <div className="left">
        <div>
          <div className="logo">
            <img src="/assets/logo.svg" alt="logo" />
          </div>
        </div>
        <div className="content">{children}</div>
        <div className="footer"></div>
      </div>
      <div className="right">
        <img src={image} alt="image" />
      </div>
    </div>
  );
}
